import React, { Component, Fragment } from "react";
import request, { NodeURL } from "../../../src/api/api";
import { Alert, Row, InputGroupAddon, InputGroupText } from "reactstrap";
import { AvFeedback, AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { toast, ToastContainer } from "react-toastify";

class forgotpassword extends Component {
  state = {
    email: "",
    mailalert: false,
    mailerror: false,
    nomail: false,
    logo_loder: false,
    agency_company_logo: ''
  };

  componentDidMount = () => {
    const subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : false;
    request({
      url: "/site/agencies",
      method: "POST",
    }).then((res) => {
      this.setState({ logo_loder: true });
      const filteredlist = res.response.result && res.response.result.filter((list) => list.domain.toString() === subdomain.toString());
      this.setState({ agency_company_logo: filteredlist && filteredlist[0] && filteredlist[0].company_logo, agency_company_name: filteredlist && filteredlist[0] && filteredlist[0].company_name }, () => {
        this.setState({ logo_loder: false });
      });
    })
  };

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  OnFormSubmit = e => {
    request({
      url: "/candidate/forgotpassword",
      method: "POST",
      data: { email: this.state.email, windows_url: `${window.location.origin}/candidate/` }
    }).then(res => {
      if (res.status === 1) {
        toast.success(res.response);
        setTimeout(() => {
          return  this.props.history.push({ pathname: "/candidate/login" });
        }, 2000);
      } else if (res.status === 0) {
        toast.error(res.response);
      }
    });
  };

  log_in = (e) => {
    e.preventDefault();
    this.props.history.push({ pathname: "/login" });
  }

  render() {
    return (
      <>
        <Fragment>
          <ToastContainer position="top-right" autoClose={2500} closeOnClick />

          <section className="section login-spaces">
              <div className="container">
                  <div className="row form">
                  <div className="agency-boxes login-cont">
                    <div className="box-width">
                      <div className="employee-forms">
                        <div className="new-agency-body">
                          <div className="new-agency-login">
                          <img src={this.state.agency_company_logo && this.state.agency_company_logo.length > 0 ? `${NodeURL}/${this.state.agency_company_logo}` : null} alt="" />
                          </div>
                          <h4>Forgot Your Password ?</h4>
                          <form >
                            <AvForm onValidSubmit={this.OnFormSubmit}>
                             
                                  <AvGroup className="input-group">
                                    {/* <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="icon-user" />
                                      </InputGroupText>
                                    </InputGroupAddon> */}
                                    <AvInput type="text" name="email" placeholder="Enter Your Email" onChange={this.onChange} value={this.state.email} required />
                                    <AvFeedback>Email is invalid!</AvFeedback>
                                  </AvGroup>
                                
                              <div className="mid-btns">
                                  <button className="login-btns" type="submit" value="Send">Submit</button>
                                  <p className="back-login "><a style={{ cursor: 'pointer' }} className="btn-link text-danger" onClick={(e) => { this.log_in(e) }} >Go to Login</a></p>
                               
                              </div>

                              
                            </AvForm>
                          </form>
                        </div>
                      </div>
                    </div>
                    </div>    
                  </div>
              </div>
          </section>
          {/* <div className="page-wrapper">
            <div className="container-fluid">
              <div className="authentication-main">
                <div className="row">
                  <div className="col-md-12 p-0">
                    <div className="auth-innerright">
                      <div className="reset-password-box">
                        <div className="text-center new-agency-login"><img src={this.state.agency_company_logo && this.state.agency_company_logo.length > 0 ? `${NodeURL}/${this.state.agency_company_logo}` : null} alt="" /></div>
                        <div className="card mt-4 mb-0">
                          
                        </div>
                        <Row>
                          {this.state.mailalert ? <Alert color="info">Check your email , Follow the instructions and Reset Password!</Alert> : null}
                          {this.state.mailerror ? <Alert color="danger">Please Enter Valid Email Address!</Alert> : null}
                          {this.state.nomail ? <Alert color="danger">Please Enter Valid Email Address!</Alert> : null}
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </Fragment>
      </>
    );
  }
}

export default forgotpassword;
